import ItodoImage from "../../../elements/itodo-img";
import { NavLink } from "react-router-dom";
import { blogData } from "../../../../globals/blogData";

function SectionBlogs1() {
    // Convert blogData object to array for easier mapping
    const blogPosts = Object.values(blogData);

    return (
        <>
            <div className="section-full p-t110 p-b80 sx-bg-white sx-latest-blog-outer wow fadeInDown" data-wow-duration="1000ms">
                <div className="container">
                    {/* TITLE START */}
                    <div className="section-head center">
                        <div className="sx-head-s-title">Our Blogs</div>
                        <div className="sx-head-l-title">
                            <h2 className="sx-title">Our Latest News</h2>
                        </div>
                    </div>
                    {/* TITLE END */}
                    <div className="section-content">
                        <div className="owl-carousel sx-latest-blog-1-carousel m-b30">
                            {blogPosts.map((blog) => (
                                <div className="item" key={blog.id}>
                                    <div className="sx-latest-post-st-1">
                                        <div className="sx-post-media sx-img-effect img-reflection">
                                            <NavLink to={`/blogs/${blog.id}`}>
                                                <ItodoImage src={blog.image} alt={blog.title} />
                                            </NavLink>
                                        </div>
                                        <div className="sx-post-info p-t30">
                                            <div className="sx-post-meta ">
                                                <ul>
                                                    <li className="post-date">
                                                        <NavLink to={`/blogs/${blog.id}`}>
                                                            <i className="fa fa-calendar" />{blog.date}
                                                        </NavLink>
                                                    </li>
                                                    <li className="post-author">
                                                        <NavLink to={`/blogs/${blog.id}`}>
                                                            <i className="fa fa-comments" />{blog.comments} Comments
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="sx-post-title ">
                                                <h4 className="post-title">
                                                    <NavLink to={`/blogs/${blog.id}`}>{blog.title}</NavLink>
                                                </h4>
                                            </div>
                                            <div className="sx-post-readmore">
                                                <NavLink 
                                                    to={`/blogs/${blog.id}`} 
                                                    title="READ MORE" 
                                                    rel="bookmark" 
                                                    className="site-button icon"
                                                >
                                                    <i className="fa fa-long-arrow-right" />Read More
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionBlogs1;